export default __webpack_public_path__ + "static/media/collect-select.c16a97b2.webp";